import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CAREER_PAGE_CONFIG } from './page-screen-config';
import { PageEditor } from './PageEditor';
import { usePagesList } from './use-pages';

/**
 * The sidebar "Career" entry renders here at the stable `/career` URL (rather
 * than redirecting to `/pages/:id`) so the Career sidebar item stays selected
 * while editing. The Careers page is a CMS custom page (slug 'career'); we
 * resolve its id at runtime - the id isn't stable across environments - and
 * hand it to the shared PageEditor. Falls back to the Custom Pages list when
 * the page can't be found (e.g. the career seed hasn't run here).
 */
export const CareerEditor = (): React.JSX.Element | null => {
  const navigate = useNavigate();
  const { data, isLoading } = usePagesList({ search: 'career', pageSize: 20 });
  const page = data?.data.find((p) => p.slug === 'career');

  useEffect(() => {
    if (!isLoading && !page) navigate('/pages', { replace: true });
  }, [isLoading, page, navigate]);

  if (isLoading || !page) {
    return (
      <div className="text-muted-foreground flex h-full items-center justify-center p-8 text-sm">
        Opening Careers page…
      </div>
    );
  }

  return <PageEditor pageId={page.id} config={CAREER_PAGE_CONFIG} />;
};
